/* eslint-disable no-nested-ternary */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-deprecated */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { useDropzone } from 'react-dropzone';
import { ReactComponent } from '@formio/react';
import { FormattedMessage, IntlProvider, useIntl } from 'react-intl';
import { Tooltip } from '../../../canvasComponents/index';
import { ListGroup } from 'react-bootstrap';
import '../utils/FileUpload/FileUpload.scss';
import { BsFileEarmarkArrowDown, BsFileEarmarkX } from 'react-icons/bs';
import useDidMountEffect from '../../../hooks/useDidMountEffect';
import { getPreSignedURL, deleteS3File, getDocument } from '../../../services/documentService';
import CustomUploadFileSettingsForm from './CustomUploadFile.settingsForm';
import { FileUploadModal } from './FileUploadModal/FileUploadModal';
import { convertBytesTo, convertMinSize, convertMaxSize } from '../utils/convertSize';
import { checkAcceptedExtensions } from '../utils/fileExtensions';
import { renameFile } from '../utils/functions';
import { BFFbaseURL, avBucket, mainBucket } from '../../../config';
import uploadLogo from '../../../img/global/downloadLg.svg';
import closeIcon from '../../../img/nav/close.svg';
import getLocalParams from '../localizationCustoms';
import messages from './messages';
import FormioErrorHandler, { useErrorStatus } from '../../../components/FormioErrorHandler/FormioErrorPopup';

function CustomUploadFile(props) {
  const [acceptedFiles, setAcceptedFiles] = useState([]);
  const [rejectedFiles, setRejectedFiles] = useState([]);
  const [maxSize, setMaxSize] = useState(10000000);
  const [minSize, setMinSize] = useState(0);
  const [filePattern, setFilePattern] = useState('');
  const [maxFiles, setMaxFiles] = useState(10);
  const [fileStatus, setFileStatus] = useState({});
  const [isEnterManually, setIsEnterManually] = useState(false);
  const [showModal, setShowModal] = useState({ isOpen: false, removedFiles: [] });
  const eventSources = useRef([]);
  const claimNumber = window.sessionStorage.getItem('claimNumber');
  const claimId = window.sessionStorage.getItem('claimId');
  const { globalErrorMessage, typeOfFiles, enterManually } = props.component;
  const intl = useIntl();
  const { setError } = useErrorStatus();

  const closeEventSources = () => {
    eventSources.current.forEach((eventSource) => {
      if (eventSource?.readyState < 2) {
        eventSource.close();
      }
    });
  };

  // unmount of component
  useEffect(() => () => closeEventSources(), []);

  // onClick
  const focusedStyle = {
    borderColor: '#147582',
    borderStyle: 'solid',
    borderWidth: 2,
  };

  // drag and drop
  const acceptStyle = {
    borderColor: '#147582',
    backgroundColor: '#d9f0f4',
    borderStyle: 'dashed',
    borderWidth: 1,
  };

  // drag and drop
  const rejectStyle = {
    borderColor: '#147582',
    backgroundColor: '#d9f0f4',
    borderStyle: 'dashed',
    borderWidth: 1,
  };

  useEffect(() => {
    if (props.component.filePattern && props.component.filePattern !== '') {
      const acceptedExtensions = props.component.filePattern.split(',');
      if (acceptedExtensions.length) {
        setFilePattern(checkAcceptedExtensions(acceptedExtensions));
      }
    }
    if (props.component.maxFiles && props.component.maxFiles !== '') {
      setMaxFiles(parseInt(props.component.maxFiles, 10));
    }
    if (props.component.fileMinimumSize && props.component.fileMinimumSize !== '') {
      setMinSize(() => convertMinSize(props.component.fileMinimumSize, minSize));
    }
    if (props.component.fileMaximumSize && props.component.fileMaximumSize !== '') {
      setMaxSize(() => convertMaxSize(props.component.fileMaximumSize, maxSize));
    }
  }, [props.component.fileMinimumSize, props.component.fileMaximumSize, props.component.filePattern, props.component.maxFiles]);

  useEffect(() => {
    if (Object.keys(fileStatus).length > 0) {
      if (fileStatus.filename === 'checkingForVirus') {
        acceptedFiles.forEach((acceptedFile) => {
          if (acceptedFile.status !== 'UPLOADED - No Virus') {
            updateFileStatus(acceptedFile.name, `UPLOAD FAILED - ${convertBytesTo(acceptedFile.size)}`);
          }
        });
      } else {
        updateFileStatus(fileStatus.filename, fileStatus.status);
      }
    }
  }, [fileStatus]);

  const getDocuments = async (uploadedDocuments) => {
    try {
      const getDocumentsResponse = await getDocument(
        claimNumber,
        mainBucket,
      );
      if (getDocumentsResponse.getDocument?.documents) {
        const files = [];
        getDocumentsResponse.getDocument?.documents.forEach((gd) => {
          gd.status = 'UPLOADED - No Virus';
          if (uploadedDocuments.some((ud) => ud.name === gd.name && ud.type === gd.type)) {
            files.push(gd);
          }
        });
        updateDocuments(files);
      }
    } catch (error) {
      console.log('TODO CALL ERROR SERVICE');
    }
  };

  useEffect(() => {
    const { value } = props || null;
    if (acceptedFiles.length === 0 && value?.uploadedDocuments?.length) {
      getDocuments(value.uploadedDocuments);
    }
    setIsEnterManually(value?.isEnterManually);
  }, [props.value]);

  useDidMountEffect(() => {
    updateDocuments();
  }, [acceptedFiles, rejectedFiles, isEnterManually]);

  const removeAcceptedFiles = async (fileObj) => {
    try {
      if (fileObj.status === 'UPLOADED - No Virus' || fileObj.status === 'UPLOADED - Checking for Virus') {
        const deleteResponse = await deleteS3File(mainBucket, claimNumber, typeOfFiles, fileObj.name);
        if (deleteResponse.deleteS3File.deletedFiles && deleteResponse.deleteS3File.deletedFiles.length > 0) {
          setAcceptedFiles((prevStateAcceptedFiles) => prevStateAcceptedFiles.filter((file) => file.name !== fileObj.name));
          if (fileObj.status !== 'UPLOADED - Checking for Virus') {
            setRejectedFiles((prevStateRejectedFiles) => prevStateRejectedFiles.filter((file) => file.file.name !== fileObj.name && file.errors.includes('Hmm! Looks like this is a duplicate file.')));
          } else {
            const virusFile = [];
            virusFile.push({ file: fileObj, errors: [intl.formatMessage({ id: 'UPLOAD FAILED - Oops! It looks like this file is unsafe.', defaultValue: 'Oops! It looks like this file is unsafe.' })] });
            setRejectedFiles((prevState) => [...prevState, ...virusFile]);
          }
        }
      } else if (fileObj.status === `UPLOAD FAILED - ${convertBytesTo(fileObj.size)}`) {
        setAcceptedFiles((prevStateAcceptedFiles) => prevStateAcceptedFiles.filter((file) => file.name !== fileObj.name));
      }
    } catch (error) {
      console.log('TODO CALL ERROR SERVICE');
    }
  };

  const removeRejectedFiles = (rejectedFile) => {
    setRejectedFiles(
      rejectedFiles.filter((file) => file.file.name !== rejectedFile.file.name),
    );
  };

  const updateFileStatus = (filename, status) => {
    // loop over the Accepted list and find the provided id.
    const updatedAcceptedFilesList = acceptedFiles.map((file) => {
      if (file.name === filename && file.status !== `UPLOAD FAILED - ${convertBytesTo(file.size)}`) {
        file.status = status;
        return file; // everything that was already in item, and updates "status"
      }
      return file; // else return unmodified item  */
    });

    setAcceptedFiles(updatedAcceptedFilesList); // set state to new object with updated list
  };

  const updateDocuments = (files) => {
    let uploadedDocuments = [];
    let uploadFailedDocuments = [];
    if (files) {
      uploadedDocuments = [...files];
      setAcceptedFiles(files);
    } else {
      uploadedDocuments = acceptedFiles.map((filteredFile) => ({ name: filteredFile.name, type: typeOfFiles, size: filteredFile.size, status: filteredFile.status }));
      uploadFailedDocuments = acceptedFiles.filter((file) => file.status.includes('UPLOAD FAILED'));
    }
    props.onChange({
      claimNumber,
      rejectedFiles: [...rejectedFiles, ...uploadFailedDocuments],
      uploadedDocuments,
      isEnterManually,
    });
  };

  const uploadFilesToS3 = async (file) => {
    if (claimNumber === 'undefined' || claimNumber === 'null') {
      return setFileStatus({ filename: file.name, status: `UPLOAD FAILED - ${convertBytesTo(file.size)}` });
    }
    // build requestPayload
    const requestPayload = {
      claimNumber,
      documents: [
        {
          extension: file.name.substr(file.name.lastIndexOf('.') + 1),
          name: file.name,
          type: typeOfFiles,
        },
      ],
      avBucket,
    };

    try {
      const preSignedURL = await getPreSignedURL(
        requestPayload.claimNumber,
        requestPayload.documents,
        requestPayload.avBucket,
      );

      if (preSignedURL.getPreSignedURL.documents[0].url) {
        setFileStatus({ filename: file.name, status: `UPLOADING...0% - ${convertBytesTo(file.size)}` });

        const result = await fetch(preSignedURL.getPreSignedURL.documents[0].url, {
          method: 'PUT',
          headers: {
            'Content-Type': file.type,
          },
          body: file,
        });

        if (result.status === 200) {
          checkForVirus(result, file);
        }
      } else {
        setFileStatus({ filename: file.name, status: `UPLOAD FAILED - ${convertBytesTo(file.size)}` });
      }
    } catch (error) {
      if (error.code === 'ERR_NETWORK') {
        setError({
          type: 'CONNECTION_ERROR',
        });
      }
      setFileStatus({ filename: file.name, status: `UPLOAD FAILED - ${convertBytesTo(file.size)}` });
    }
  };

  function checkForVirus(result, file) {
    setFileStatus({ filename: file.name, status: 'UPLOADED - Checking for Virus' });
    const eventSource = new EventSource(`${BFFbaseURL}/virusScanResult/${claimId}?file=${file.name}`, { withCredentials: true });
    eventSources.current = [...eventSources.current, eventSource];
    eventSource.onmessage = (e) => {
      const response = JSON.parse(e.data) || {};
      if (Object.prototype.hasOwnProperty.call(response, 'uploadDocuments')) {
        const fileResponse = response?.uploadDocuments?.find((d) => d.name === file.name);
        if (e.isTrusted && !fileResponse?.virusDetected) {
          setFileStatus({ filename: file.name, status: 'UPLOADED - No Virus' });
        } else {
          removeAcceptedFiles({ name: file.name, status: 'UPLOADED - Checking for Virus' });
        }
      }
      eventSource.close();
    };
    eventSource.onerror = () => {
      setFileStatus({ filename: 'checkingForVirus' });
      eventSource.close();
    };
  }

  const onDrop = (validFiles, fileRejections) => {
    let filesToUpload = [];
    const nTotalOfFiles = acceptedFiles.length;
    const availableSlots = maxFiles - nTotalOfFiles;

    if (acceptedFiles.length > 0) {
      validFiles.forEach((file) => {
        let exists = false;
        let duplicatedFile = {};
        for (let i = 0; i < acceptedFiles.length; i += 1) {
          if (acceptedFiles[i].name === file.name) {
            exists = true;
            duplicatedFile = { name: acceptedFiles[i].name.substr(0, acceptedFiles[i].name.lastIndexOf('.')), extension: acceptedFiles[i].name.split('.').pop() };
            break;
          }
        }
        if (!exists) {
          file.status = 'WAITING FOR UPLOAD';
          filesToUpload.push(file);
        } else {
          const regexExpression = /([a-zA-z\s\d]+\([1-9]+\))/;
          const filesWithSamePrefix = acceptedFiles.filter((acceptedFile) => ((acceptedFile.name.includes(duplicatedFile.name) && regexExpression.test(acceptedFile.name)))).length;
          const renamedFile = renameFile(file, `${duplicatedFile.name}(${filesWithSamePrefix + 1}).${duplicatedFile.extension}`);
          renamedFile.status = 'WAITING FOR UPLOAD';
          filesToUpload.push(renamedFile);
        }
      });
    } else {
      validFiles.forEach((file) => {
        file.status = 'WAITING FOR UPLOAD';
        filesToUpload.push(file);
      });
    }

    if (filesToUpload.length <= availableSlots) {
      setAcceptedFiles((prevState) => [...prevState, ...filesToUpload]);
    } else {
      const remainingFiles = filesToUpload.slice(0, availableSlots);
      const removedFiles = filesToUpload.slice(availableSlots - filesToUpload.length);
      filesToUpload = [...remainingFiles];
      setShowModal({ isOpen: true, removedFiles });
      setAcceptedFiles((prevState) => [...prevState, ...remainingFiles]);
    }

    fileRejections.forEach((file) => {
      const detectedErrors = [];
      file.errors.forEach((err) => {
        let size = 0;
        if (err.code === 'file-too-large') {
          size = err.message.match(/\d+/g);

          detectedErrors.push(
            `${intl.formatMessage({ id: 'Oops! This file exceeds the', defaultValue: 'Oops! This file exceeds the' })} ${convertBytesTo(size)}${intl.formatMessage({ id: ' limit. You can email this file to your Claims Professional later.', defaultValue: ' limit. You can email this file to your Claims team member later.' })}`,
          );
        } else if (err.code === 'file-invalid-type') {
          detectedErrors.push('FILE TYPE NOT ACCEPTED');
        }
        file.errors = detectedErrors;
      });
    });

    setRejectedFiles((prevState) => [...prevState, ...fileRejections]);

    if (filesToUpload.length > 0) {
      filesToUpload.forEach(async (file) => {
        try {
          await uploadFilesToS3(file);
        } catch (error) {
          setFileStatus({ filename: file.name, status: `UPLOAD FAILED - ${convertBytesTo(file.size)}` });
        }
      });
    }
  };
  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject, isDragActive } = useDropzone({
    onDrop,
    accept: filePattern,
    minSize,
    maxSize,
    disabled: acceptedFiles.length >= maxFiles,
  });

  const style = useMemo(
    () => ({
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject, isDragActive],
  );

  const cleanEnterManuallyFields = () => {
    const { component: { enterManuallyContainer }, data } = props;
    for (const key in data[enterManuallyContainer]) {
      if (typeof data[enterManuallyContainer][key] === 'object' && ('value' in data[enterManuallyContainer][key])) {
        data[enterManuallyContainer][key].value = '';
      } else if (typeof data[enterManuallyContainer][key] === 'object' && key !== 'police2' && key !== 'fire2') {
        for (const key2 in data[enterManuallyContainer][key]) {
          if (typeof data[enterManuallyContainer][key][key2] === 'object') {
            data[enterManuallyContainer][key][key2].value = '';
          }
        }
      }
    }
  };

  return (
    <>
      {/* TITLE AND TOOLTIP */}
      {!props.component.hideCustomLabel && (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <label className="label-question">
            <FormattedMessage id={props.component.label} defaultMessage={props.component.label} />
          </label>
          <Tooltip id="uploadfiles_tooltip" title={intl.formatMessage(messages.tooltip_title)} primary>
            <FormattedMessage
              {...messages.tooltip}
              values={{
                videoAudioImageAndTextDocuments: (
                  <a href={intl.formatMessage(messages.videoAudioImageAndTextDocumentsUrl)} target="_blank" rel="noreferrer">
                    {intl.formatMessage(messages.videoAudioImageAndTextDocuments)}
                  </a>
                ),
              }}
            />
          </Tooltip>
        </div>
      )}

      {/* FILE DROPZONE */}
      <ListGroup
        id="uploadedFiles"
        style={{ backgroundColor: '#fff' }}
      >
        {rejectedFiles.length > 0 && (
          <>
            <ListGroup id="rejectedFiles">
              {rejectedFiles.map((file, index) => (
                <ListGroup.Item
                  as="li"
                  key={`rejectedItem_${file.file.name}_${index}`}
                  className="rejectedFile"
                >
                  <div className="file-description cut-text">
                    <div className="file-icon">
                      <BsFileEarmarkX style={{ color: '#E12160' }} />
                    </div>
                    <div className="file-info-notuploaded fs-exclude">
                      {file.file.name}
                      {file.errors.map((error) => (
                        <div key={`error_${file.file.name}_${index}`} className="file-status-notuploaded-failed" style={{ fontSize: '12px', fontWeight: 'bold', color: '#E12160' }}>
                          {error === 'FILE TYPE NOT ACCEPTED' ? (
                            <FormattedMessage
                              {...messages.fileTypeNotAccepted}
                              values={{
                                learnMoreAbout: (
                                  <a style={{ fontSize: '12px', fontWeight: 'bold', color: '#147582' }} href={intl.formatMessage(messages.learnMoreAboutUrl)} target="_blank" rel="noreferrer">
                                    {intl.formatMessage(messages.learnMoreAbout)}
                                  </a>
                                ),
                              }}
                            />
                          )
                            : <FormattedMessage id={error} defaultMessage={error} />}
                        </div>
                      ))}
                    </div>
                  </div>
                  <button
                    type="button"
                    className="listItemButton"
                    onClick={() => removeRejectedFiles(file)}
                  >
                    <img className="listItemButtonIcon" src={closeIcon} alt="Close" />
                  </button>
                </ListGroup.Item>
              ))}
            </ListGroup>
            <ListGroup id="globalErrorMessage">
              <ListGroup.Item
                as="li"
                className="listGroup"
              // key="lItem_globalErrorMessage"
              // style={{ border: '1px solid #ddd', padding: '10px 15px' }}
              >
                <div className="errorMessageGlobal">
                  <FormattedMessage id={globalErrorMessage} defaultMessage={globalErrorMessage} />
                </div>
              </ListGroup.Item>
            </ListGroup>
          </>
        )}
        {acceptedFiles.length > 0 && (
          <ListGroup id="acceptedFiles">
            {acceptedFiles.map((file, index) => (
              <ListGroup.Item
                as="li"
                key={`acceptedItem_${file.name}_${index}`}
                className="accepted-file"
              >
                <div className="file-description cut-text">
                  <div className="file-icon">
                    <BsFileEarmarkArrowDown style={{ color: file.status.includes('UPLOAD FAILED') ? '#E12160' : '#147582' }} />
                  </div>
                  {file.status.includes('UPLOADED - No Virus')
                    ? (
                      <div className="file-info-uploaded fs-exclude">
                        {file.name}
                      </div>
                    )
                    : (
                      <div className="file-info-notuploaded fs-exclude">
                        {file.name}
                        {!file.status.includes('WAITING FOR UPLOAD') && (file.status.includes('UPLOAD FAILED') ? (
                          (
                            <div className="file-status-notuploaded-failed">
                              <FormattedMessage
                                id="UPLOAD FAILED"
                                defaultMessage={file.status}
                                values={{
                                  size: `${convertBytesTo(file.size)}`,
                                }}
                              />
                            </div>
                          )
                        ) : (file.status.includes('UPLOADING') || file.status.includes('Checking')) ? (
                          <div className="file-status-notuploaded">
                            <FormattedMessage
                              id="UPLOADING"
                              defaultMessage={file.status}
                              values={{
                                size: `${convertBytesTo(file.size)}`,
                              }}
                            />
                          </div>
                        )
                          : (
                            <div className="file-status-notuploaded">
                              <FormattedMessage id={file.status} defaultMessage={file.status} />
                            </div>
                          ))}
                      </div>
                    )}
                </div>
                {file.status.includes('UPLOADED - No Virus') || file.status.includes('UPLOAD FAILED') ? (
                  <button
                    type="button"
                    className="listItemButton"
                    onClick={() => removeAcceptedFiles(file)}
                  >
                    <img className="listItemButtonIcon" src={closeIcon} alt="Close" />
                  </button>
                ) : null}
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </ListGroup>
      <div {...getRootProps({ style, className: acceptedFiles.length >= maxFiles ? 'dropzone-disabled' : 'dropzone-active' })}>
        <input {...getInputProps()} />
        <div className="upload-icon">
          <img className="upload-logo" src={uploadLogo} alt="Upload Logo" />
        </div>
        <p className="upload-box-text">
          <FormattedMessage {...messages.dragAndDrop} />
        </p>
      </div>
      {acceptedFiles.length >= maxFiles && (
        <p className="errorMessageBlack cut-text"><FormattedMessage id={props.component.maxFilesErrorMessage} defaultMessage={props.component.maxFilesErrorMessage} /></p>
      )}
      {enterManually && !isEnterManually && (
        <button
          type="button"
          tabIndex="0"
          className="enterManuallyButton"
          style={{ marginTop: '5px' }}
          onClick={() => setIsEnterManually(true)}
        > <FormattedMessage id="Enter manually" defaultMessage="Enter manually" />
        </button>
      )}
      {enterManually && isEnterManually && (
        <div style={{ display: 'flex', textAlign: 'center', marginTop: '16px' }}>
          <p className="enterManuallyTitle"><FormattedMessage id={props.component.enterManuallyTitle} defaultMessage={props.component.enterManuallyTitle} /></p>
          <button
            type="button"
            tabIndex="0"
            className="removeEnterManuallyButton"
            onClick={() => { setIsEnterManually(false); cleanEnterManuallyFields(); }}
          >
            <FormattedMessage id="Remove" defaultMessage="Remove" />
          </button>
        </div>
      )}
      <FileUploadModal
        maxFilesModalErrorMessage={props.component?.maxFilesModalErrorMessage}
        showModal={showModal}
        setShowModal={setShowModal}
        localParams={props.localParams}
      />
    </>
  );
}

export default class UploadFileComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'Custom Upload File',
      icon: 'file',
      group: 'premium',
      weight: 80,
      documentation: '/userguide/#file',
      schema: UploadFileComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customuploadfile',
      },
      extend,
    );
  }

  /*
   * Defines the settingsForm when editing a component in the builder.
   */
  static editForm = CustomUploadFileSettingsForm;

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */
  attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);

    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <FormioErrorHandler>
          <CustomUploadFile
            inputRef={(refer) => {
              instance = refer;
            }}
            component={this.component} // These are the component settings if you want to use them to render the component.
            value={this.dataForSetting || this.dataValue} // The starting value of the component.
            data={this.data}
            onChange={this.updateValue}
            localParams={localParams}
          />
        </FormioErrorHandler>
      </IntlProvider>,
      element,
      // eslint-disable-next-line no-return-assign
      () => (this.reactInstance = instance),
    );
  }

  /**
   * Automatically detach any react components.
   *
   * @param element
   */
  // eslint-disable-next-line class-methods-use-this
  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
